<template lang="pug">
  div.e-user-files.user-files
    e-table-inner(
    :showDeleteButton="false"
    :itemsEndpoint="itemsEndpoint"
    )
      template(slot="name" slot-scope="props")
        div.file
          div.file-content
            div.img
            div.filename
              p.name {{props.row.name}}
              p.size {{props.row.size}}
          div.buttons
            button(@click="downloadItem(props.row)").row-download

</template>

<script>
  import saveFile from '../../utils/saveFile'

  export default {
    name: 'e-user-files',
    props: {
      endpoint: {
        type: Function,
        // eslint-disable-next-line
        default: function (route) {
          return null
        },
        required: true
      },
      downloadFile: {
        type: Function,
        // eslint-disable-next-line
        default: function (item) {
          return {
            endpoint: '',
            fileName: ''
          }
        },
        required: true
      }
    },
    methods: {
      itemsEndpoint (ctx) {
        let route = {
          query: {
            sort: ctx.currentSort || null,
            page: ctx.paginateObj ? ctx.paginateObj.page : null,
            'per-page': ctx.paginateObj ? ctx.paginateObj['per-page'] : null
          }
        }

        return {
          url: this.endpoint(route)
        }
      },
      downloadItem (item) {
        let {endpoint, fileName} = this.downloadFile(item)
        this.$bar.start()
        this.$store.dispatch(
          'downloadFile',
          {endpoint}
        ).then(r => {
          saveFile({blob: r.request.response, fileName})
          this.$bar.finish()
        }).catch(e => {
          console.error(e)
          this.$bar.finish()
          this.$e.errorBox(e)
        })
      }
    }
  }
</script>
